import React, { useState } from 'react';
import { Box } from '@wix/design-system';
import { CombinedValueControlProps } from '../../types';
import { CombinedControlConverter } from '../converters';

export const OpacityControl: React.FC<CombinedValueControlProps> = ({
  getControl,
  combinedValue,
  onCombinedValueChange,
  mixMode,
}) => {
  const [Control] = useState(
    () => getControl('opacity', 'cssPropertyType').Component,
  );
  const converter = new CombinedControlConverter('ShadowOpacity');
  return (
    <Control
      label={mixMode ? 'Opacity (mixed values)' : 'Opacity'} // TODO: add translations
      value={converter.importValue(combinedValue)}
      onChange={(updatedValue) => {
        onCombinedValueChange(converter.exportValue(updatedValue));
      }}
    />
  );
};
